import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA Service Worker with AGGRESSIVE auto-update so installed PWAs
// never stay stuck on an old build.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      // `updateViaCache: 'none'` makes the browser re-fetch /sw.js every time
      // instead of caching it for up to 24h — this is critical for installed PWAs.
      const reg = await navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' });

      // Reload the page once after the new SW takes control (auto-applied update)
      let reloaded = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (reloaded) return;
        reloaded = true;
        window.location.reload();
      });

      // If a new SW is waiting, tell it to take over immediately — no user interaction needed.
      const activateWaiting = (worker) => {
        if (!worker) return;
        worker.postMessage({ type: 'SKIP_WAITING' });
        // Also emit the legacy event so the UpdateAvailableToast can still show briefly
        window.dispatchEvent(new CustomEvent('sw-update-ready', { detail: { worker } }));
      };

      // Case A: a new SW is already waiting when the page loaded
      if (reg.waiting) activateWaiting(reg.waiting);

      // Case B: a new SW arrives while the page is open
      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            activateWaiting(newWorker);
          }
        });
      });

      // Trigger a fresh update check right now, on focus, and every 5 minutes.
      const check = () => reg.update().catch(() => {});
      check();
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') check();
      });
      window.addEventListener('focus', check);
      setInterval(check, 5 * 60 * 1000);
    } catch {
      // SW registration unsupported/failed — app still works over network
    }
  });
}
